import XHeader from 'vux/src/components/x-header/index.vue'

import printHead from '@/components/printHead'

export default {
name: 'printedInstructions',
components: {
XHeader,
printHead
},
data () {
return {

}
},
methods: {

},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/printedInstructions/script.js